import React from 'react';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import { Route, Switch } from 'react-router-dom';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import ListLandingPage from './containers/Pages/Lists/ListLandingPageConnectLazy';
import TrendingListConnect from './containers/Pages/TrendingList/TrendingListConnect';

export default function App() {
    return (
        <Switch>
            <Route
                exact
                path="/"
                /* eslint-disable react/jsx-props-no-spreading */
                render={(props) => <ListLandingPage {...props} />}
            />
            <Route
                exact
                path="/mylist"
                /* eslint-disable react/jsx-props-no-spreading */
                render={(props) => <ListLandingPage {...props} />}
            />
            <Route
                exact
                path="/savedlist"
                /* eslint-disable react/jsx-props-no-spreading */
                render={(props) => <ListLandingPage {...props} />}
            />
            <Route
                exact
                path="/trending-list"
                /* eslint-disable react/jsx-props-no-spreading */
                render={(props) => <TrendingListConnect {...props} />}
            />
            <Route component={NotFound} />
        </Switch>
    );
}
// this import is to move the common css to the root
// instead of going into lazy loaded css
App.Layout = Layout;
